import * as React from "react";
import { TTranslate } from "../../../service/locale/TranslationService";
import { FormComponentProps } from "antd/lib/form";
import EvaluationTypeForm from "./EvaluationTypeForm";
import EvaluationType, {
  IEvaluationType
} from "../../../model/evaluation/EvaluationType";

export interface State {}

export interface UpdateEvaluationTypeFormProps extends FormComponentProps {
  translate: TTranslate;
  registerFormSubmitEventHandler: any;
  rowData: IEvaluationType;
}

class UpdateEvaluationTypeForm extends React.Component<
  UpdateEvaluationTypeFormProps,
  State
> {
  componentDidMount() {
    const { registerFormSubmitEventHandler, rowData } = this.props;
    registerFormSubmitEventHandler(e => {
      e.preventDefault();
      let updatedRecord;
      this.props.form.validateFields((err, values) => {
        if (!err) {
          updatedRecord = EvaluationType(values);
          updatedRecord.id = rowData.id;
        }
      });
      return updatedRecord;
    });
  }

  render() {
    const { translate, rowData } = this.props;

    const { getFieldDecorator } = this.props.form;

    return (
      <EvaluationTypeForm
        getFieldDecorator={getFieldDecorator}
        translate={translate}
        rowData={rowData}
      />
    );
  }
}

export default UpdateEvaluationTypeForm;
